import { useState } from 'react'
import { Button } from '@/common/ui/button'
import { Icons } from '@/common/ui/icons'
import useQueryDepositTransactionsById from '@/modules/transaction/api/hooks/useQueryDepositTransactionsById'
import PaymentGatewayErrorsModal from '../../PaymentGatewayErrorsModal'

interface DepositErrorLogsButtonProps {
	id: string
	errorCount: number
}

export default function DepositErrorLogsButton({
	id,
	errorCount,
}: DepositErrorLogsButtonProps) {
	const [open, setOpen] = useState(false)
	const { data: deposit, isLoading } = useQueryDepositTransactionsById(id, {
		enabled: open,
	})

	if (errorCount === 0) {
		return <span>-</span>
	}

	return (
		<>
			<Button
				variant="destructive"
				size="sm"
				className="font-medium shadow-sm"
				onClick={() => setOpen(true)}
			>
				{isLoading && open ? (
					<Icons.spinner className="h-4 w-4 animate-spin" />
				) : (
					<>
						<Icons.warning className="h-4 w-4" />
						สาเหตุ ({errorCount})
					</>
				)}
			</Button>
			{deposit && (
				<PaymentGatewayErrorsModal
					open={open}
					onOpenChange={setOpen}
					errors={deposit.paymentGatewayErrors || []}
					transactionId={id}
				/>
			)}
		</>
	)
}
